import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  onlyShowAdditionalInfoLastWorkingDay: boolean
}

export const DEFAULT_FILTER: Filter = {
  onlyShowAdditionalInfoLastWorkingDay: false,
}

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const AdditionalInfoFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <Checkbox
    label="Just show agent additional info last working day"
    checked={filter.onlyShowAdditionalInfoLastWorkingDay}
    onChange={e =>
      onChangeFilter({
        ...filter,
        onlyShowAdditionalInfoLastWorkingDay: e.target.checked,
      })
    }
  />
)

export default AdditionalInfoFilter
